/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Validation_Fromrequired3Inputs */

const en_coinvestments_editemail_validation_fromrequired3 = /** @type {(inputs: Coinvestments_Editemail_Validation_Fromrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender cannot be empty`)
};

/**
* | output |
* | --- |
* | "Sender cannot be empty" |
*
* @param {Coinvestments_Editemail_Validation_Fromrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_validation_fromrequired3 = /** @type {((inputs?: Coinvestments_Editemail_Validation_Fromrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Validation_Fromrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_validation_fromrequired3(inputs)
});
export { coinvestments_editemail_validation_fromrequired3 as "coInvestments_editEmail_validation_fromRequired" }